var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"animateEl",class:[
      _vm.rootClass,
      { 'inline-block': _vm.inlineBlock },
      _vm.immediately ? 'animate-init' : 'animate-element'
    ],style:(_vm.totalDelay > 0 && { 'transition-delay': _vm.totalDelay + 'ms' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }